import { endOfMonth, format, startOfMonth } from "date-fns";

export function getMonthStartEndDateString() {
  return `${format(startOfMonth(new Date()), "yyyy/MM/dd")}-${format(
    endOfMonth(new Date()),
    "yyyy/MM/dd",
  )}`;
}
